import React from 'react'
import { useIntl } from 'react-intl'
import {
  Panel,
  Flex,
  FlexItem,
  Button,
  BUTTON_VARIANT_SECONDARY,
  BUTTON_VARIANT_NEUTRAL,
  Link,
  LINK_VARIANT_HIGHLIGHT,
  Title,
  TITLE_VARIANT_M,
  Text
} from 'mailup-web-components'
import { useRecoilValue, useSetRecoilState } from 'recoil'
import { pageState } from 'Pages/EmailMessagePreview/recoil/state/page'
import { FULL_VIEW, QUICK_VIEW } from 'Pages/EmailMessagePreview/const'
import { storeGet } from 'Helpers/localStorage'
import { STORE_KEY_ACCOUNT } from 'Constants/'
import { notifyParent } from 'Helpers/notifyParent'

const BoxGoToPreview = () => {
  const intl = useIntl()
  const setView = useSetRecoilState(pageState)
  const { maxState } = useRecoilValue(pageState)
  const { IsTrial } = storeGet(STORE_KEY_ACCOUNT)
  const handleSetView = pView => {
    setView(prev => ({
      ...prev,
      view: pView
    }))
  }

  const handleShopClick = () => {
    notifyParent('redirectMainFrame', [
      '/console/mshop_Redirector.aspx?t=mshoppl'
    ])
  }

  return (
    <Panel>
      <Flex flexDirection='column' rowGap='8px'>
        <FlexItem margin='0 0 8px 0'>
          <Title variant={TITLE_VARIANT_M}>
            {intl.formatMessage({
              id: 'Load.EmailCheckUp.PreviewUsingEmailProgramsNew'
            })}
          </Title>
        </FlexItem>

        <Text>
          {intl.formatMessage({
            id: 'Load.EmailCheckUp.PreviewUsingEmailProgramsMsg'
          })}
        </Text>

        <FlexItem margin='0 0 16px 0'>
          <Flex alignItems='flex-start'>
            <Button
              onClick={() => handleSetView(QUICK_VIEW)}
              kind={BUTTON_VARIANT_SECONDARY}
              data-mu-test='quick-preview'
            >
              {intl.formatMessage({
                id: 'Load.EmailCheckUp.PreviewNewQuickPreviewsBtn'
              })}
            </Button>
          </Flex>
        </FlexItem>

        {maxState.MaxEmailPreviews === 0 && !IsTrial && (
          <>
            <FlexItem>
              {intl.formatMessage({
                id: 'Load.EmailCheckUp.PreviewViewFullPreviewMsgNew'
              })}
            </FlexItem>
            <FlexItem>
              <Flex alignItems='flex-start'>
                <Button
                  onClick={() => handleSetView(FULL_VIEW)}
                  kind={BUTTON_VARIANT_SECONDARY}
                  data-mu-test='full-preview'
                >
                  {intl.formatMessage({
                    id: 'Load.EmailCheckUp.PreviewNewFullPreviewsBtn'
                  })}
                </Button>
              </Flex>
            </FlexItem>
          </>
        )}

        {maxState.MaxEmailPreviews === 0 && IsTrial && (
          <>
            <FlexItem>
              {intl.formatMessage(
                {
                  id: 'Load.EmailCheckUp.PreviewViewFullPreviewTrialMsgNew'
                },
                {
                  link: chunks => (
                    <Link
                      variant={LINK_VARIANT_HIGHLIGHT}
                      data-mu-test='goToShop'
                      onClick={handleShopClick}
                    >
                      {chunks}
                    </Link>
                  )
                }
              )}
            </FlexItem>
            <FlexItem>
              <Flex alignItems='flex-start'>
                <Button
                  onClick={() => null}
                  kind={BUTTON_VARIANT_NEUTRAL}
                  disabled
                >
                  {intl.formatMessage({
                    id: 'Load.EmailCheckUp.PreviewViewFullPreviewBtn'
                  })}
                </Button>
              </Flex>
            </FlexItem>
          </>
        )}
      </Flex>
    </Panel>
  )
}

export default BoxGoToPreview
